import { useMemo, useState, useEffect } from "react";
import {
  EditButton,
  DeleteButton,
  Stack,
  CreateButton,
  Switch,
  Grid,
  Typography,
  useDataGrid,
  DataGrid,
  List,
} from "@pankod/refine-mui";
import { itIT } from "@mui/x-data-grid";
import useLocales from "locales/useLocales";

export default function CompList() {
  const { currentLang, defaultLang } = useLocales();

  const [filteredRows, setFilteredRows] = useState([]);
  const { dataGridProps, sortingMode, sortModel, onSortModelChange } =
    useDataGrid({
      metaData: {
        locale: defaultLang,
        fields: ["name", "code", "start", "end"],
        populate: "localizations",
        fakeParam: currentLang.value, //this is to force re-fetching data when language changes
      },
    });

  const { rows, ...restDataGridProps } = dataGridProps;

  useEffect(() => {
    setFilteredRows(rows);
  }, [rows]);

  const columns = useMemo(
    () => [
      { field: "name", headerName: "Nome", flex: 1, minWidth: 300 },
      { field: "code", headerName: "Codice", flex: 1, minWidth: 200 },
      {
        field: "start",
        headerName: "Data inizio",
        flex: 1,
        minWidth: 200,
        valueGetter: ({ row }) => {
          const date = new Date(row.start);
          return date.toLocaleDateString("it-IT");
        },
      },
      {
        field: "end",
        headerName: "Data fine",
        flex: 1,
        minWidth: 200,
        valueGetter: ({ row }) => {
          const date = new Date(row.end);
          return date.toLocaleDateString("it-IT");
        },
      },
      {
        headerName: "Azioni",
        field: "actions",
        minWidth: 50,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <EditButton hideText recordItemId={params.row.id} />
              <DeleteButton hideText recordItemId={params.row.id} />
            </Stack>
          );
        },
      },
    ],
    []
  );

  const handleFilter = (e) => {
    const filter = e.target.checked;

    if (filter) {
      const today = new Date();
      const filteredData = rows.filter((item) => {
        const start = new Date(item.start);
        const end = new Date(item.end);
        return start <= today && end >= today;
      });
      setFilteredRows(filteredData);
    } else {
      setFilteredRows(rows);
    }
  };

  return (
    <List
      resource="coupons"
      //createButtonProps={{ size: "small" }}
      headerButtons={<CreateButton>Nuovo</CreateButton>}
      headerButtonProps={{ size: "small" }}
      title={<Typography variant="h5">Coupons</Typography>}
    >
      <Grid item xs={12} md={12} sx={{ height: "100%" }}>
        <Stack direction="row" alignItems="center" spacing={2} mb={3}>
          <Typography variant="subtitle1" color="text.secondary">
            Mostra solo eventi in corso
          </Typography>
          <Switch onChange={handleFilter} />
        </Stack>
      </Grid>

      <DataGrid
        rows={filteredRows}
        {...restDataGridProps}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        sortingMode={sortingMode}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        autoHeight
      />
    </List>
  );
}
